import { render, staticRenderFns } from "./KSRViewingAppointment.vue?vue&type=template&id=56cd34be&scoped=true&"
import script from "./KSRViewingAppointment.vue?vue&type=script&lang=js&"
export * from "./KSRViewingAppointment.vue?vue&type=script&lang=js&"
import style0 from "./KSRViewingAppointment.vue?vue&type=style&index=0&id=56cd34be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd34be",
  null
  
)

export default component.exports